/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationEnrollmentParentViewModel } from "../types/CourseRegistrationEnrollmentParentViewModel.ts";
import { courseRegistrationEnrollmentChildrenFilterViewModelSchema } from "./courseRegistrationEnrollmentChildrenFilterViewModelSchema.ts";

export const courseRegistrationEnrollmentParentViewModelSchema = z.object({
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  courseCode: z.string().describe("Código do curso.").nullish(),
  courseName: z
    .string()
    .describe(
      "Nome do curso formatado com código (ex.: 'MBA001 - MBA em Gestão').",
    )
    .nullish(),
  poloId: z.optional(
    z.number().int().describe("ID do polo. Valor 0 indica Pecege Online."),
  ),
  poloName: z
    .string()
    .describe(
      "Nome do polo. Retorna 'Pecege Online' quando não há polo vinculado.",
    )
    .nullish(),
  classStudentId: z.optional(z.number().int().describe("ID da turma.")),
  classStudentCode: z.string().describe("Código da turma.").nullish(),
  classStudentDescription: z
    .string()
    .describe(
      "Descrição da turma formatada com código (ex.: 'T2024 - Turma 2024').",
    )
    .nullish(),
  dateStart: z.optional(
    z.string().datetime().describe("Data de início da turma."),
  ),
  dateEnd: z
    .string()
    .datetime()
    .describe("Data de término da turma. Opcional.")
    .nullish(),
  studentsNumber: z.optional(
    z.number().int().describe("Quantidade de alunos neste grupo."),
  ),
  childrenFilter: z.optional(
    z.lazy(() => courseRegistrationEnrollmentChildrenFilterViewModelSchema),
  ),
}) as unknown as ToZod<CourseRegistrationEnrollmentParentViewModel>;
